import { render } from "./BoxMediaTypesKeywords.vue?vue&type=template&id=744060a6"
import script from "./BoxMediaTypesKeywords.vue?vue&type=script&setup=true&lang=js"
export * from "./BoxMediaTypesKeywords.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Extensions/Lfmpublications/Vue/components/BoxMediaTypesKeywords.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "744060a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('744060a6', __exports__)) {
    api.reload('744060a6', __exports__)
  }
  
  module.hot.accept("./BoxMediaTypesKeywords.vue?vue&type=template&id=744060a6", () => {
    api.rerender('744060a6', render)
  })

}


export default __exports__